(function () {
  if (window.__atcFeedbackInit) return;
  window.__atcFeedbackInit = true;

  var ADD_RE = /\/cart\/add(\.js)?(\?|$|#)/i;
  var SUCCESS_DURATION_MS = 1500;
  var lastClickedBtn = null;
  var lastClickedAt = 0;
  var CLICK_TIMEOUT_MS = 8000;

  function showSuccess(btn) {
    if (!btn) return;
    btn.classList.add('is-added-to-cart');
    setTimeout(function () {
      btn.classList.remove('is-added-to-cart');
    }, SUCCESS_DURATION_MS);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.m-add-to-cart');
    if (btn) {
      lastClickedBtn = btn;
      lastClickedAt = Date.now();
    }
  }, true);

  function maybeShowSuccess() {
    if (!lastClickedBtn) return;
    if (Date.now() - lastClickedAt > CLICK_TIMEOUT_MS) return;
    showSuccess(lastClickedBtn);
    lastClickedBtn = null;
  }

  var origFetch = window.fetch;
  if (typeof origFetch === 'function') {
    window.fetch = function () {
      var args = arguments;
      var url = '';
      try {
        var first = args[0];
        url = typeof first === 'string' ? first : (first && first.url) || '';
      } catch (_) {}
      var promise = origFetch.apply(this, args);
      if (url && ADD_RE.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) maybeShowSuccess();
        }, function () {});
      }
      return promise;
    };
  }

  var origOpen = XMLHttpRequest.prototype.open;
  var origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (method, url) {
    this.__atcUrl = url;
    return origOpen.apply(this, arguments);
  };
  XMLHttpRequest.prototype.send = function () {
    var url = this.__atcUrl;
    if (url && ADD_RE.test(url)) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) {
          maybeShowSuccess();
        }
      });
    }
    return origSend.apply(this, arguments);
  };
})();
